import LogoImage from "~/content/images/logo.svg?react";
import MenuIcon from "~/content/icons/menu.svg?react";

// Reuse the real stylesheet rather than copying rules, so the replica cannot
// drift visually from the header it is replicating.
import "./MainHeader.css";

/**
 * Inert, dependency-free replica of `<MainHeader>`, shared by the surfaces
 * that must show the app header without a session: the print bundle
 * (`PrintAppHeader`) and the Designer preview (`PreviewAppHeader`).
 *
 * Why a replica instead of the real component: `MainHeader` imports
 * `react-router`'s `Link`, `useSignOut`, `Modal` and `MainMenuDrawer` — none
 * of which those surfaces can satisfy. Both exist because their output is a
 * picture of the participant's screen, so the page has to look like that
 * screen — app chrome included.
 *
 * Markup mirrors `MainHeader` class-for-class so `MainHeader.css` styles it,
 * with two substitutions:
 *   - the logo `<Link>` becomes a plain `<span>` (nothing to navigate to)
 *   - the menu `<button>` becomes a `<span>`, keeping the glyph but not the
 *     affordance; the drawer and help modal are omitted entirely since neither
 *     is visible on the participant's screen until they act.
 *
 * The logo is imported as an inline SVG component (`?react`), NOT as a URL the
 * way `MainHeader` does it. A URL import becomes a relative `/assets/...`
 * path, and the print bundle renders in an opaque origin (`setContent` →
 * `about:blank`) where a relative URL resolves against nothing — the logo
 * would print broken. Inlining the markup means there is no request to fail.
 */
export function StaticMainHeader({ className, testId }) {
    return (
        <header className={`main-header ${className}`} data-testid={testId}>
            <span className="main-header__logo">
                <LogoImage
                    className="main-header__logo-image"
                    role="img"
                    aria-label="Viedoc Me Logo"
                />
            </span>
            {/* Decorative here: it names an action the viewer cannot take. */}
            <span className="main-header__menu-button" aria-hidden="true">
                <MenuIcon className="main-header__menu-button-icon" />
            </span>
        </header>
    );
}
